import "whatwg-fetch";

const loginForms = document.querySelectorAll(".e-login-form");

function initLoginForm(form) {
	document.addEventListener("DOMContentLoaded", init);

	function init() {
		addEventListeners();
	}

	function addEventListeners() {
		form.addEventListener("submit", submit);

		// Do something else other than redirect after login
		if (form.dataset.event) {
			form.addEventListener(
				form.dataset.event,
				function (e) {
					e.detail.run();
				},
				false
			);
		}
	}

	function submit(e) {
		e.preventDefault();

		form.classList.add("loading");

		var formData = new FormData(form);

		// Submit
		fetch(mainScriptData.ajaxUrl, {
			method: "POST",
			body: formData,
		})
			.then(function (response) {
				if (response.ok) {
					return response.json();
				}
			})
			.then(function (data) {
				// Show error on failure
				if (!data.success) {
					showError(data.data.error);
					form.classList.remove("loading");
				}

				// Redirect on success
				if (data.success) {
					if (form.dataset.event) {
						form.dispatchEvent(window.globalAccountsEvents[form.dataset.event]);
					} else {
						window.location.href = data.data.redirect;
					}

					setTimeout(function () {
						form.classList.remove("loading");
					}, 5000);
				}
			})
			.catch(function (error) {
				console.warn(error);
			});
	}

	function showError(error) {
		let errorMessage = form.querySelector(
			".e-login-form__notice--error div span"
		);

		errorMessage.innerHTML = error;

		form.classList.add("error");
	}
}

if (loginForms) {
	loginForms.forEach(function (form) {
		if (form.dataset.ajax == "1") {
			initLoginForm(form);
		}
	});
}
